import { useTimetableBlockQuery, useTimetableBlocksQuery } from '../../../types/planung-graphql-client-defs';

/**
 * Name und aktive Version eines Zeitraums kommen aus seinen Stundenplänen. Mutationen an
 * Stundenplänen und Versionen liefern andere Typnamen als diese Abfragen; damit sie sie trotzdem
 * verwerfen, hängen deren Typnamen hier an. Jeder Aufrufer der Abfragen muss diesen Context
 * mitgeben, auch die Route-Loader.
 */
export const TIMETABLE_BLOCK_QUERY_CONTEXT = {
  additionalTypenames: ['TimetableBlockItem', 'TimetableBlock', 'TimetableItem', 'Timetable', 'TimetableVersion'],
};

/**
 * Für die Mutationen an Zeiträumen: verwirft die Abfragen oben (auch nach dem Löschen, das keinen
 * Zeitraum zurückgibt) und alles, was noch den Knotentyp `TimetableBlock` enthält (Berichte).
 */
export const TIMETABLE_BLOCK_MUTATION_CONTEXT = {
  additionalTypenames: ['TimetableBlockItem', 'TimetableBlock'],
};

/**
 * Zeiträume des Schuljahres nach Beginn. Mit `onlyWithActiveVersion` nur die, in denen ein
 * Stundenplan eine aktive Version hat; mit `date` (YYYY-MM-DD) nur die, die an dem Tag gelten.
 */
export const useTimetableBlocks = (
  schoolYearUuid: string | undefined,
  options?: { onlyWithActiveVersion?: boolean; date?: string },
) => {
  const [{ data, fetching }] = useTimetableBlocksQuery({
    variables: {
      schoolYearUuid: schoolYearUuid ?? '',
      onlyWithActiveVersion: options?.onlyWithActiveVersion ?? false,
      date: options?.date ?? null,
    },
    pause: !schoolYearUuid,
    context: TIMETABLE_BLOCK_QUERY_CONTEXT,
  });
  return { timetableBlocks: data?.timetableBlocks, fetching };
};

export const useTimetableBlockByUuid = (uuid: string | undefined, options?: { pause?: boolean }) => {
  const [{ data, fetching }] = useTimetableBlockQuery({
    variables: { uuid: uuid ?? '' },
    pause: !uuid || options?.pause,
    context: TIMETABLE_BLOCK_QUERY_CONTEXT,
  });
  return { timetableBlock: data?.timetableBlock ?? undefined, fetching };
};
